import React from 'react';

interface BadgeProps {
  children: React.ReactNode;
  color?: 'accent' | 'purple' | 'success' | 'warning' | 'error';
}

const colorMap: Record<string, React.CSSProperties> = {
  accent:  { background: 'var(--accent)',   color: '#000' },
  purple:  { background: 'var(--accent2)',  color: '#fff' },
  success: { background: 'var(--success)',  color: '#000' },
  warning: { background: 'var(--warning)',  color: '#000' },
  error:   { background: 'var(--error)',    color: '#fff' },
};

const Badge: React.FC<BadgeProps> = ({ children, color = 'accent' }) => (
  <span
    style={{
      display: 'inline-block',
      padding: '2px 7px',
      borderRadius: 'var(--radius-full)',
      fontSize: '0.65rem',
      fontWeight: 700,
      letterSpacing: '0.04em',
      ...colorMap[color],
    }}
  >
    {children}
  </span>
);

export default Badge;
